import "./App.css";
import "./3DEffects.css";
import "./page-shared.css";
import Dashboard from "./Commponents/Dashboard";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Staking from "./Commponents/Staking";
import LevelIncome from "./Commponents/LevelIncome";
import Refferal from "./Commponents/Refferal";
import HeritageIncome from "./Commponents/HeritageIncome";
import CommunityIncome from "./Commponents/CommunityIncome";
import Stake from "./Commponents/Stake";
import Withdrawal from "./Commponents/Withdrawal";
import Profile from "./Commponents/Profile";
import EditProfile from "./Commponents/EditProfile";
import Affiliate from "./Commponents/Affiliate";
import StakingIncome from "./Commponents/StakingIncome";
import CommunityRoyalty from "./Commponents/CommunityRoyalty";
import Unstake from "./Commponents/Unstake";
import Ledger from "./Commponents/Ledger";
import CommingSoon from "./Commponents/CommingSoon";
import Deposit from "./Commponents/Deposit";
import TransferNow from "./Commponents/TransferNow";
import OTPModal from "./Commponents/OTPModal";
import Tree from "./Commponents/Tree";
import Register from "./Commponents/Register";
import VerifyEmail from "./Commponents/VerifyEmail";
import OTPVerify2 from "./Commponents/OTPVerify2";
import ProtectedRoutes from "./ProtecteRoutes";
import ChangePassword from "./Commponents/ChangePassword";
import NewPassword from "./Commponents/NewPassword";
import PasswordVerify3 from "./Commponents/PasswordVerify3";
import ForgetPassword from "./Commponents/ForgetPassword";
import WithdrwlHistory from "./Commponents/WithdrwlHistory";
import WithdrawalAddressHistory from "./Commponents/WithdrawalAddressHistory";
import DepositHistory from "./Commponents/DepositHistory";
import UpdateName from "./Commponents/UpdateName";
import CreateTicket from "./Commponents/Support/CreateTicket";
import MyTickets from "./Commponents/Support/MyTickets";
import TicketDetails from "./Commponents/Support/TicketDetails";
import SupportPage from "./Commponents/Support/SupportPage";
import LoginChangePassword from "./Commponents/LoginChangePassword";
import TransferEcosystem from "./Commponents/TransferEcosystem";

function App() {
  return (
    <>
      {/* <Dashboard/> */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Affiliate />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify" element={<OTPModal />} />
          <Route path="/loginChangePS" element={<LoginChangePassword />} />

          <Route element={<ProtectedRoutes />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/deposithistory" element={<DepositHistory />} />
            <Route path="/verify3" element={<PasswordVerify3 />} />
            <Route path="/enternewPs" element={<NewPassword />} />
            <Route path="/verify2" element={<OTPVerify2 />} />
            <Route path="/staking" element={<Staking />} />
            <Route path="/refferal" element={<Refferal />} />
            <Route path="/level-income" element={<LevelIncome />} />
            <Route path="/weeklyincome" element={<StakingIncome />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/support/create-ticket" element={<CreateTicket />} />
            <Route path="/support/my-tickets" element={<MyTickets />} />
            <Route path="/support/ticket/:ticketId" element={<TicketDetails />} />
            <Route path="/primeincome" element={<HeritageIncome />} />
            <Route path="/rankinc" element={<CommunityRoyalty />} />
            <Route path="/stake" element={<Stake />} />
            <Route path="/ecosystem-wallet-transfer" element={<TransferEcosystem />} />
            <Route path="/tree" element={<Tree />} />
            <Route path="/deposit" element={<Deposit />} />
            <Route path="/wtihdrawal" element={<Withdrawal />} />
            <Route path="/transfer" element={<TransferNow />} />
            <Route path="/wtihdrawalhistory" element={<WithdrwlHistory />} />
            <Route path="/withdrwalAdress" element={<WithdrawalAddressHistory />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/ForgetPassword" element={<ForgetPassword />} />
            <Route path="/changepassword" element={<ChangePassword />} />
            <Route path="/verifyEmail" element={<VerifyEmail />} />
            <Route path="/updateName" element={<UpdateName />} />

            {/* not use */}
            <Route path="/unstake" element={<Unstake />} />
            <Route path="/community-income" element={<CommunityIncome />} />
            <Route path="/ledger" element={<Ledger />} />
            <Route path="/comming-soon" element={<CommingSoon />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
